module.exports = __webpack_public_path__ + "img/compass.512b0eb1.png";